// src/app/culinary-partners/page.jsx
import React from "react";
import { culinaryPartners } from "../../lib/data";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "../../components/ui/card";
import { Button } from "../../components/ui/button";
import { Badge } from "../../components/ui/badge";
import { ChefHat, ArrowRight, Utensils, Sparkles } from "lucide-react";

export default function CulinaryPartnersPage() {
  const navigate = (partnerId) => {
    window.location.hash = `#/culinary-partners/${partnerId}`;
  };

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="flex items-center justify-center mb-4">
            <div className="w-16 h-16 rounded-full bg-primary flex items-center justify-center">
              <ChefHat className="h-8 w-8 text-primary-foreground" />
            </div>
          </div>
          <h1 className="text-5xl font-bold mb-4 bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
            Culinary Partners
          </h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Discover the perfect flavors for your event from our curated list of culinary experts
          </p>
        </div>

        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-16">
          {culinaryPartners.map((partner) => (
            <Card
              key={partner.id}
              className="group overflow-hidden hover:shadow-2xl transition-all duration-300 backdrop-blur-sm bg-card/70 border-2 border-transparent hover:border-border cursor-pointer"
              onClick={() => navigate(partner.id)}
            >
              <div className="aspect-video bg-gradient-to-br from-secondary/60 to-accent/40 overflow-hidden relative">
                <div className="w-full h-full flex items-center justify-center">
                  {partner.specialty === "Sweet" ? (
                    <Sparkles className="h-20 w-20 text-primary/40" />
                  ) : (
                    <Utensils className="h-20 w-20 text-primary/40" />
                  )}
                </div>
                <Badge className="absolute top-4 right-4 bg-primary text-primary-foreground border-none">
                  {partner.specialty}
                </Badge>
              </div>
              <CardHeader>
                <CardTitle className="text-2xl group-hover:text-transparent group-hover:bg-gradient-to-r group-hover:from-primary group-hover:to-accent group-hover:bg-clip-text transition-all duration-300">
                  {partner.name}
                </CardTitle>
                <CardDescription className="text-base">
                  {partner.description}
                </CardDescription>
              </CardHeader>
              <CardContent>
                <div className="flex items-center justify-between">
                  <p className="text-sm text-muted-foreground">
                    {partner.offerings?.length || 0} offerings available
                  </p>
                  <div className="flex items-center text-primary font-semibold group-hover:translate-x-2 transition-transform duration-300">
                    View Menu
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Request Custom Caterer CTA */}
        <Card className="max-w-3xl mx-auto backdrop-blur-xl bg-card/70 border-2 border-border">
          <CardHeader>
            <CardTitle className="text-3xl bg-gradient-to-r from-primary to-accent bg-clip-text text-transparent">
              Can't Find Your Preferred Caterer?
            </CardTitle>
            <CardDescription className="text-base">
              Let us know who you have in mind! We're happy to reach out and coordinate with new partners.
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Button
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 text-lg py-6 shadow-lg shadow-primary/30"
              onClick={() => window.location.hash = '#/booking'}
            >
              Request Connection
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
